import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Alert, Button } from 'antd';
import posthog from 'posthog-js';

export function cookieConsentGiven() {
  const storedConsent = localStorage.getItem('cookie_consent');

  if (!storedConsent) {
    return 'undecided';
  }
  return storedConsent;
}

export const AppBanner = () => {
  const [consentGiven, setConsentGiven] = useState('');

  useEffect(() => {
    setConsentGiven(cookieConsentGiven());
  }, []);

  useEffect(() => {
    if (consentGiven !== '') {
      posthog.set_config({ persistence: consentGiven === 'yes' ? 'localStorage+cookie' : 'memory' });
    }
  }, [consentGiven]);

  const handleAcceptCookies = () => {
    localStorage.setItem('cookie_consent', 'yes');
    setConsentGiven('yes');
  };

  const handleDeclineCookies = () => {
    localStorage.setItem('cookie_consent', 'no');
    setConsentGiven('no');
  };

  const StyledBanner = styled('div')`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1100;
  `;

  return (
    <StyledBanner>
      {consentGiven === 'undecided' && (
        <Alert
          message="Cookie Consent"
          description={
            <span>
              We use cookies to enhance your experience and analyze usage. Learn more in our
              <a
                style={{ marginLeft: '0.25rem' }}
                href="https://identity.bluefield.app/Legal/Cookie"
                target="_blank"
                rel="noreferrer"
              >
                Cookie Policy
              </a>
              .
            </span>
          }
          type="info"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
          action={
            <div>
              <Button onClick={handleAcceptCookies} style={{ marginBottom: 0 }} type="primary">
                Accept
              </Button>
              <Button onClick={handleDeclineCookies} danger style={{ marginBottom: 0 }} type="ghost">
                Decline
              </Button>
            </div>
          }
        />
      )}
    </StyledBanner>
  );
};
